/** Keep keyboard navigation inside the modal, including reverse Tab at its first control. */
export function trapDialogFocus(event: KeyboardEvent, dialog: HTMLDialogElement): void {
  if (event.key !== 'Tab') return;
  const selector =
    'a[href], button, input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  const controls = Array.from(dialog.querySelectorAll<HTMLElement>(selector)).filter(
    (element) => !element.hasAttribute('disabled') && element.getClientRects().length > 0,
  );
  const first = controls[0];
  const last = controls[controls.length - 1];
  if (!first || !last) {
    event.preventDefault();
    return;
  }
  const active = document.activeElement;
  if ((event.shiftKey && active === first) || (!event.shiftKey && active === last)) {
    event.preventDefault();
    (event.shiftKey ? last : first).focus();
  }
}
